import type { ResourceDescriptor } from '@/services/uiActions/resources'
import { requireResourceId } from '@/services/uiActions/resources'
import { agentCanvas, agentDialog, agentsNew } from '@constants/routing'

export const teammateResource: ResourceDescriptor = {
  kind: 'teammate',
  routes: {
    ui_open_teammate: operation =>
      operation.view === 'chat' ? agentDialog(requireResourceId(operation)) : agentCanvas(requireResourceId(operation)),
    ui_create_teammate: () => agentsNew(),
    ui_update_teammate: operation => agentCanvas(requireResourceId(operation)),
    ui_delete_teammate: operation => agentCanvas(requireResourceId(operation)),
    ui_chat_teammate: operation => agentDialog(requireResourceId(operation)),
  },
}
